import React, { useRef } from 'react';
import { BetslipOpenBets } from './betslip-open-bets';
import { BetslipOpenBetsV2 } from './betslip-open-bets-v2';
import { BetslipOpenBetsWithoutSession } from './betslip-open-bets-without-session';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { createBem } from '@om-fe/utils';
import { BetslipOpenBetsTabs } from './betslip-tabs';
import config, { BetslipConfig } from '@om-fe/core/utils/config';

const betslipOpenBetsBem = createBem('BettingAreaOpenBets');

interface BetslipWrapperProps {
    readonly openModal?: () => void,
    readonly closeModal?: () => void,
    readonly className?: string,
    readonly onTabChanged?: (tab: BetslipOpenBetsTabs) => void,
}

interface BetslipWrapperComponentStateProps {
    readonly isAuthenticated: boolean;
}

type BetslipWrapperComponentProps = BetslipWrapperComponentStateProps & BetslipWrapperProps;

function BetslipWrapperComponent(
    {
        isAuthenticated,
        closeModal,
        openModal,
        className,
        onTabChanged,
    }: BetslipWrapperComponentProps) {
    const parentContainerRef = useRef();
    const betslip: BetslipConfig = config().betslip;
    const enabledCashoutAble: boolean = betslip?.enabledCashoutAbleFilter ?? false;

    return (
        <div className={betslipOpenBetsBem({
            modifiers: {
                isAuthenticated: isAuthenticated,
            },
            extra: className,
        })}
             ref={parentContainerRef}
        >
            {isAuthenticated
                ?
                    enabledCashoutAble
                        ? (
                            <BetslipOpenBetsV2
                                parentContainerRef={parentContainerRef}
                                closeModal={closeModal}
                                openModal={openModal}
                                onTabChanged={onTabChanged}
                            />
                        )
                        : (
                            <BetslipOpenBets
                                parentContainerRef={parentContainerRef}
                                closeModal={closeModal}
                                openModal={openModal}
                                onTabChanged={onTabChanged}
                            />
                        )
                : (
                    <BetslipOpenBetsWithoutSession
                        parentContainerRef={parentContainerRef}
                        closeModal={closeModal}
                        openModal={openModal}
                        onTabChanged={onTabChanged}
                    />
                )
            }
        </div>
    );
}

export const BetslipWrapperDesktop: React.ComponentType<BetslipWrapperProps> = compose<BetslipWrapperComponentStateProps>(
    connect((state: AppState) => {
        return {
            isAuthenticated: !!state.session?.info?.isAuthenticated,
        };
    }),
)(BetslipWrapperComponent);